import fetch from "auth/FetchInterceptor";
import { ApiConstant } from "constants/ApiConstant";
import Utils from "utils";
import qs from "qs";
const CountryService = {};

CountryService.listCountry = function (params) {
  return fetch({
    url: ApiConstant.COUNTRY_LIST,
    method: "get",
    params: Utils.filterHeaderParams(params),
    paramsSerializer: (params) =>
      qs.stringify(params, {
        arrayFormat: "repeat",
      }),
  });
};
CountryService.downloadCountryExcel = function (data, params) {
  const ids = Array.isArray(data) ? data : [data];
  return fetch({
    url: ApiConstant.COUNTRY_EXCEL_DOWNLOAD,
    method: "PATCH",
    params: Utils.filterHeaderParams(params),
    data: { ids },
  });
};
CountryService.singleCountry = function (params) {
  return fetch({
    url: ApiConstant.COUNTRY_DETAILS,
    method: "get",
    params: Utils.filterHeaderParams(params),
  });
};
CountryService.addCountry = function (data, params) {
  return fetch({
    url: ApiConstant.COUNTRY_CREATE,
    method: "POST",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};
CountryService.updateCountry = function (data, params) {
  return fetch({
    url: ApiConstant.COUNTRY_UPDATE,
    method: "PATCH",
    params: Utils.filterHeaderParams(params),
    data: data,
  });
};
CountryService.bulkStatusUpdate = function (data, status) {
  const payload = {
    status: status,
    ids: Array.isArray(data) ? data : [data],
  };
  return fetch({
    url: ApiConstant.COUNTRY_BULK_STATUS_UPDATE,
    method: "PATCH",
    data: payload,
  });
};

export default CountryService;
